import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, Collapse, Spinner } from 'reactstrap'
import LoadingAbsolute from '../../LoadingAbsolute'
import Header from '../../Header'
import './index.css'
import ArrowDownGreenSvg from '../../../assets/icons/ArrowDownGreenSvg'
import ArrowUpGreenSvg from '../../../assets/icons/ArrowUpGreenSvg'
import MapPNG from '../../../assets/png/map.png'
import { IconDeviceFloppy } from '@tabler/icons-react'
import useErrorModal from '../../../hooks/useErrorModal'
import ErrorModal from '../../ErrorModal'
import { IconAlertSquareRounded } from '@tabler/icons-react'
// Gelişmiş pulse animasyonu için CSS
const enhancedPulseAnimation = `
  @keyframes enhancedPulse {
    0% {
      opacity: 1;
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
    }
    
    50% {
      opacity: 0.85;
      transform: scale(1.02);
      box-shadow: 0 0 0 10px rgba(239, 68, 68, 0);
    }
    
    100% {
      opacity: 1;
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
    }
  }

  .enhanced-pulse-alert {
    animation: enhancedPulse 1.5s ease-in-out infinite;
    border: 2px solid #ef4444;
  }

  .enhanced-pulse-alert:hover {
    animation-play-state: paused;
  }
`

const HobiBahcesiKosullar = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [karaaslan, setKaraaslan] = useState(false)
  const [saracoglu, setSaracoglu] = useState(false)
  const {
    isVisible: errorIsVisible,
    message: errorMessage,
    showError,
    closeError: errorCloseError,
  } = useErrorModal()

  const [checkboxes, setCheckboxes] = useState({
    madde1: false,
    madde2: false,
    madde3: false,
    madde4: false,
    madde5: false,
    madde6: false,
    // madde7: false,
    // madde8: false,
    // madde9: false,
    // madde10: false,
  })

  const [checkboxes2, setCheckboxes2] = useState({
    madde1: false,
    madde2: false,
    madde3: false,
    madde4: false,
    madde5: false,
    madde6: false,
    madde7: false,
    madde8: false,
  })

  const handleChange = (madde, setCheckbox) => {
    setCheckbox((prev) => ({
      ...prev,
      [madde]: !prev[madde],
    }))
  }

  const allChecked =
    Object.values(checkboxes).every((value) => value === true) &&
    Object.values(checkboxes2).every((value) => value === true)

  const toggleMapKaraaslan = () => setKaraaslan(!karaaslan)
  const toggleMapSaracoglu = () => setSaracoglu(!saracoglu)

  const openAddressKaraaslan = (e) => {
    e.preventDefault()
    window.open(
      `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.9522594272726!2d32.5547751!3d37.8145872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d09b5c9981d477%3A0x7daa880e57b3ab38!2sKaraaslan%20Hobi%20Bah%C3%A7esi!5e0!3m2!1str!2str!4v1737373172627!5m2!1str!2str`
    )
  }

  const openAddressSaracoglu = (e) => {
    e.preventDefault()
    window.open(
      `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.5681019711415!2d32.5681127!3d37.8235842!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d09b1301107f93%3A0x68c8105d49bb145d!2sHobi%20Bah%C3%A7eleri!5e0!3m2!1str!2str!4v1737373127145!5m2!1str!2str`
    )
  }

  const buttons = [
    {
      id: 0,
      title: 'Karaaslan Hobi Bahçesi',
      toggle: toggleMapKaraaslan,
      open: karaaslan,
      onClick: openAddressKaraaslan,
      mapSrc:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.9522594272726!2d32.5547751!3d37.8145872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d09b5c9981d477%3A0x7daa880e57b3ab38!2sKaraaslan%20Hobi%20Bah%C3%A7esi!5e0!3m2!1str!2str!4v1737373172627!5m2!1str!2str',
    },
    {
      id: 1,
      title: 'Saraçoğlu Hobi Bahçesi',
      toggle: toggleMapSaracoglu,
      open: saracoglu,
      onClick: openAddressSaracoglu,
      mapSrc:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.5681019711415!2d32.5681127!3d37.8235842!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d09b1301107f93%3A0x68c8105d49bb145d!2sHobi%20Bah%C3%A7eleri!5e0!3m2!1str!2str!4v1737373127145!5m2!1str!2str',
    },
  ]

  useEffect(() => {
    setLoading(false)
  }, [state])

  const list1 = [
    // <div>
    //   Hobi bahçeleri için başvuru ücreti <b>{state?.ucret ?? '-'}₺</b>'dir. Kura sonucuna göre hak sahibi olunamaması durumunda iadesi mümkün olmayacaktır.
    // </div>,
    <div>
      Hobi bahçeleri için başvuru ücreti <b>{state?.ucret ?? '-'}₺</b>'dir. Kura sonucuna göre hak
      sahibi olunamaması durumunda iadesi mümkün olmayacaktır.
    </div>,
    <div>
      Başvuru sahibi <b>Karatay ilçesi</b> sınırlarında ikamet etmelidir. İkamet bilgisi nüfus
      servislerinden başvuru esnasında anlık olarak gerçekleştirilmektedir.
    </div>,
    <div>
      Başvuru sahibinin belediyemize <b>borcu bulunmamalıdır.</b>
    </div>,
    <div>
      Müracaat sahibi noter huzurunda yapılan kurada hak sahibi olması durumunda, ikinci bir kişiye{' '}
      <b>parsel devri yapamayacaktır.</b>
    </div>,
    <div>
      Hobi bahçeleri tahsisi <b>01.03.2025 - 30.10.2029</b> tarihleri arasını kapsayacaktır.
      Kullanım şartlarına uymayan ve herhangi bir nedenle belediyemiz hobi bahçelerini boşaltmak
      zorunda kalan hak sahipleri, parselleri üzerinde hiçbir hak talebinde bulunamayacaklardır.
    </div>,
    <div>
      Kazanan talihlilerin hobi bahçesi tahsis kayıtları <b>10.02.2025 - 21.02.2025</b> tarihleri
      arasında mesai saatleri içerisinde Karatay Belediyesi Hizmet Masasından yapılacaktır.
    </div>,
    <div>
      Belirlenen süre içerisinde sözleşmeye gelmeyen talihliler haklarını kaybedeceklerdir ve
      yedeklerden hak kazananlar <b>24.02.2025 - 28.02.2025</b> tarihleri arasında sırasıyla davet
      edilecektir.
    </div>,
    <div>
      Başvurular saraçoğlu ve karaaslan hobi bahçeleri için alınmaktadır. Kura karışık olarak
      çekilecektir.
    </div>,
  ]

  const list2 = [
    <div>
      Hobi bahçesi hizmet ücreti <b>2025</b> yılı için yıllık <b>2.000₺</b> olup, takip eden
      yıllardaki ücret her yıl belediye meclisinin alacağı karar doğrultusunda belirlenecek ve o
      yılın <b>1 Mart gününden önce belediye veznelerine </b>
      yatırılacaktır. Aksi halde hobi bahçesi kullanım hakkı kaybedilecektir.
    </div>,
    <div>
      Karaaslan hobi bahçeleri için kategorilere göre kulübe kullanım ücretleri{' '}
      <b>(5.000 TL ile 20.000 TL arasında)</b> sözleşmeden önce bir defaya mahsus olmak üzere
      belediye veznesine yatırılacak olup makbuz sözleşme imzalama zamanında Karatay Belediyesi
      personeline ibraz edilecektir.
    </div>,
    <div>
      Tahsisler, komisyon ve noter huzurunda kura yöntemi ile yedekli olarak gerçekleşir. Önce
      dolu-boş şeklinde asıl kullanıcı ve yedek kullanıcı belirlenecek. Dolu çıkan talihliler
      içerisinde şu anki parsel sahibi var ise aynı parselinde kalması sağlanacak ve geriye kalan
      parseller için parsel numarası belirlemek amacıyla talihliler arasında tekraren kura
      çekilecektir.
    </div>,
  ]

  return (
    <>
      {loading ? <LoadingAbsolute text={'Yükleniyor'} /> : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 999,
          }}
        >
          <Header onClick={() => navigate(-1)} />
        </div>
        <div className='hobiHeadTitle fw-bold mt-3'>
          <div>Başvuru Öncesi</div> <div>Dikkat Edilmesi Gerekenler</div>
        </div>
        <style>{enhancedPulseAnimation}</style>
        <div className='hobiWarning enhanced-pulse-alert'>
          <div>
            <IconAlertSquareRounded className='text-danger' />
          </div>
          <div className='fw-normal'>
            Başvurunuzu gerçekleştirmeden önce aşağıda yer alan bilgilendirme metninin{' '}
            <b>tüm maddelerini okuyup, onaylamanız</b> gerekmektedir.
          </div>
          <div>
            Başvurunuzu gerçekleştirmeden önce aşağıda yer alan bilgilendirme metninin tamamını
            okuyunuz.
          </div>
        </div>
        <div className='hobiTitle' style={{ margin: '1rem' }}>
          Genel Konular
        </div>
        {list1?.map((item, index) => (
          <div key={index} className='hobiListNewItem'>
            <label className='custom-checkbox-wrapper'>
              <input
                type='checkbox'
                style={{ display: 'none' }}
                checked={checkboxes['madde' + (index + 1)]}
                onChange={() => handleChange('madde' + (index + 1), setCheckboxes)}
              />
              <span className='custom-checkmark'></span>
              <div className='hobiListItemDesc'>{item}</div>
            </label>
          </div>
        ))}
        <div className='hobiTitle' style={{ margin: '1rem' }}>
          Hizmet ve Kulübe Kullanım Ücreti
        </div>
        {list2?.map((item, index) => (
          <div key={index} className='hobiListNewItem'>
            <label className='custom-checkbox-wrapper'>
              <input
                type='checkbox'
                style={{ display: 'none' }}
                checked={checkboxes2['madde' + (index + 1)]}
                onChange={() => handleChange('madde' + (index + 1), setCheckboxes2)}
              />
              <span className='custom-checkmark'></span>
              <div className='hobiListItemDesc'>{item}</div>
            </label>
          </div>
        ))}
        {/* <div className='hobiWarningYellow'>
          <div>
            <InfoCircleYellowSvg width={'1rem'} />
          </div>
          <div>
            Kura sonucunda hobi bahçesi tahsis edilen vatandaşlarımız{' '}
            <b> 01.03.2025 - 30.10.2029</b> tarihleri arasında ekim ve dikim
            faaliyetlerini gerçekleştirebileceklerdir.
          </div>
        </div> */}
        {buttons?.map((item) => (
          <div key={item.id}>
            <div
              className='hobiMapButton'
              onClick={item.toggle}
              style={{
                transition: 'border-color 0.8s ease',
                boxShadow: 'none',
                borderColor: '#efefe7',
              }}
            >
              <div className='hobiMapButton-text'>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <p style={{ margin: 0, fontWeight: 'normal' }}>{item.title}</p>
                </div>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '50px',
                    backgroundColor: '#fff',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: !item.open ? '.1rem 0 0 0' : '0 0 .1rem 0',
                      minWidth: '1.5rem',
                      minHeight: '1.5rem',
                      fontSize: '11px',
                    }}
                  >
                    {!item.open ? (
                      <ArrowDownGreenSvg width='.8rem' />
                    ) : (
                      <ArrowUpGreenSvg width='.8rem' />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='hobiMap'>
              <Collapse isOpen={item.open}>
                <div className='mapDiv'>
                  <img alt='' src={MapPNG} />
                  <iframe
                    title='This is a unique title'
                    src={item.mapSrc}
                    width='800'
                    height='600'
                    style={{ border: '0', width: '100%', height: '300px' }}
                    allowfullscreen=''
                    loading='lazy'
                    referrerpolicy='no-referrer-when-downgrade'
                  ></iframe>
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '15px',
                      right: '15px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginTop: '1rem',
                    }}
                  >
                    <Button
                      block
                      className='tubitakTamamla'
                      onClick={item.onClick}
                      style={{
                        fontSize: '12px',
                        backgroundColor: '#285843',
                        borderRadius: '5px',
                        padding: '.3rem .5rem',
                      }}
                    >
                      Konumu Gör
                    </Button>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        ))}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '1rem',
            marginBottom: '2rem',
          }}
        >
          <Button
            block
            onClick={() => {
              if (!allChecked) {
                showError('Tüm maddeleri onaylamanız gerekmektedir.')
              } else {
                navigate('/hobiForm', {
                  state: {
                    ucret: state?.ucret,
                  },
                })
              }
            }}
            style={{
              marginLeft: '1rem',
              marginRight: '1rem',
              backgroundColor: '#285843',
              borderRadius: '50px',
              padding: '.5rem 0',
            }}
          >
            {loading ? (
              <Spinner
                size={'sm'}
                // type="grow"
              />
            ) : (
              <div>
                <IconDeviceFloppy className='me-1' style={{ marginTop: '-5px' }} size={21} />
                Başvuruya Devam Et
              </div>
            )}
          </Button>
        </div>
      </div>
      <ErrorModal isVisible={errorIsVisible} onClose={errorCloseError} message={errorMessage} />
    </>
  )
}

export default HobiBahcesiKosullar
